module.exports = __webpack_public_path__ + "img/small-dash.4d55e595.svg";